import script from "./ReferencePayrollSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferencePayrollSection.vue?vue&type=script&setup=true&lang=js"

import "./ReferencePayrollSection.vue?vue&type=style&index=0&id=234ed0d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-234ed0d2"]])

export default __exports__